<template>
  <div
    :class="{
      page: true,
      'page-devices': true,
      content: true,
      'page--overlayed': overlayVisible,
    }"
  >
    <IconSpinner
      v-if="!isReady"
      :extra-classes="['page-devices__spinner']"
    />
    <DeviceDetail v-else :device="device" />
    <ChooseProviderPopup
      v-if="chooseProviderPopup.isVisible"
      context="global"
    />
  </div>
</template>

<script lang="ts">
import DeviceDetail from '@/components/devices/DeviceDetail.vue'
import IconSpinner from '@/components/icons/Spinner.vue'
import ChooseProviderPopup from '@/components/popups/ChooseProviderPopup.vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
import { usePopupOverlay } from '@/composables/usePopupOverlay.ts'
import { useDeviceStore } from '@/stores/useDeviceStore'
import chooseProvider from '@/components/ChooseProvider.vue'

export default {
  name: 'page-device-detail',
  components: {
    DeviceDetail,
    IconSpinner,
    ChooseProviderPopup,
  },
  setup() {
    const router = useRouter()
    const deviceStore = useDeviceStore()
    const { overlayVisible } = usePopupOverlay('global')

    const isReady = computed(async() => {
      // We need the router to be ready so we can read the deviceId param from
      // the current route.

      await router.isReady();

      return deviceStore.devicesLoaded
    })

    const device = computed(() =>  {
      const deviceId = parseInt(router.currentRoute.value.params.deviceid as string)
      return deviceStore.getDeviceById(deviceId)
    })

    const chooseProviderPopup = useSpecificPopup("chooseProvider")

    return {
      overlayVisible,
      router,
      isReady,
      device,
      chooseProviderPopup,
    }
  },
}
</script>

<style lang="scss">
.page-devices {
  &__spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2rem;
    height: 2rem;
    animation: spin 1.8s linear 0s infinite;
  }
}
</style>
